export const availabilityNotes = {
  de: 'Jeder Termin ist zunächst eine Anfrage und wird persönlich per WhatsApp bestätigt.',
  en: 'Every appointment is initially a request and is confirmed personally via WhatsApp.',
};

export const futureAvailabilityPlan = {
  source: 'google-calendar-and-sheets',
  frontendEndpoint: '/api/availability',
  notes:
    'Final availability should be loaded server-side from Google Calendar and Google Sheets. Already booked calendar entries must be filtered out before slots are returned to the frontend.',
};
